import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import logo from "@/assets/villa-rosa-icon-text-black.svg";
import logoWhite from "@/assets/villa-rosa-text-icon-white.svg";
import styles from "./Header.module.css";

const NAV = [
  { to: "/", label: "Home", end: true },
  { to: "/book-a-stay", label: "Book a Stay" },
  { to: "/book-an-event", label: "Book an Event" },
  { to: "/gallery", label: "Gallery" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const HERO_ROUTES = ["/book-an-event", "/contact"];
  const overHero = HERO_ROUTES.includes(location.pathname) && !scrolled && !open;

  return (
    <header
      className={`${styles.header} ${scrolled ? styles.scrolled : ""} ${
        overHero ? styles.overHero : ""
      }`}
    >
      <div className={`container ${styles.bar}`}>
        <Link to="/" className={styles.brand} aria-label="Villa Rosa — home">
          <img
            className={styles.logo}
            src={overHero ? logoWhite : logo}
            alt="Villa Rosa"
            width={166}
            height={38}
          />
        </Link>

        <nav
          className={`${styles.nav} ${open ? styles.navOpen : ""}`}
          aria-label="Primary"
        >
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `${styles.link} ${isActive ? styles.active : ""}`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link to="/book-a-stay" className={`btn btn--primary ${styles.navCta}`}>
            Book a Stay
          </Link>
        </nav>

        <button
          type="button"
          className={styles.toggle}
          aria-expanded={open}
          aria-controls="primary-nav"
          onClick={() => setOpen((v) => !v)}
        >
          <span className="visually-hidden">Toggle menu</span>
          <span className={`${styles.bars} ${open ? styles.barsOpen : ""}`} />
        </button>
      </div>
    </header>
  );
}
